/**
 * Empty-cart message. `content` (presentation.empty) may replace the copy and
 * actions; an empty title or `icon: false` drops that element.
 */
export default function CartEmpty({ shopUrl, content = {} }) {
	const title = content.title ?? "Your cart is empty";
	const text = content.text ?? "Looks like you haven't added anything yet. Browse our menu and find something you love!";
	const actions = content.actions || [
		{ label: "Browse Menu", url: shopUrl },
		{ label: "Back to Home", url: "/" },
	];

	return (
		<div className="zc-empty">
			{content.icon !== false && <div className="zc-empty__icon">
				<svg
					width="80"
					height="80"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
				>
					<circle cx="9" cy="21" r="1" />
					<circle cx="20" cy="21" r="1" />
					<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
				</svg>
			</div>}
			{title && <h2 className="zc-empty__title">{title}</h2>}
			{text && <p className="zc-empty__text">{text}</p>}
			{actions.length > 0 && <div className="zc-empty__actions">
				{actions.map((action, i) => (
					<a
						key={i}
						href={action.url}
						className={action.className || `zc-empty__btn zc-empty__btn--${i === 0 ? "primary" : "secondary"}`}
					>
						{action.label}
					</a>
				))}
			</div>}
		</div>
	);
}
